import * as React from 'react';

import EnterpriseExploreMenuItem from 'bundles/composable-page-header-enterprise/components/mobile/EnterpriseExploreMenuItem';
import EnterpriseExploreSubmenuWrapper from 'bundles/composable-page-header-enterprise/components/mobile/EnterpriseExploreSubmenuWrapper';
import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import GetAppMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/GetAppMenuItem';
import MobileAuthMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MobileAuthMenuItem';
import {
  MOBILE_EXPLORE_IDENTIFIER,
  MOBILE_MAIN_IDENTIFIER,
  logInButtonProps,
} from 'bundles/composable-page-header/constants';

const DefaultLoggedOutEnterpriseMobileMenuConfig = () => {
  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU]: (
          <EnterpriseExploreSubmenuWrapper
            identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_CATEGORIES_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_SKILLS_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_PROGRAM]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_PROGRAM_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_ORGANIZATION]: (
          <EnterpriseExploreSubmenuWrapper
            identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_ORGANIZATION_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_MORE]: (
          <EnterpriseExploreSubmenuWrapper identifier={MOBILE_EXPLORE_IDENTIFIER.ENTERPRISE_EXPLORE_MORE_SUBMENU} />
        ),
      }}
    >
      <EnterpriseExploreMenuItem />
      <GetAppMenuItem />
      <MobileAuthMenuItem buttons={[logInButtonProps()]} />
    </MobileMenuConfigWrapper>
  );
};

export default DefaultLoggedOutEnterpriseMobileMenuConfig;
